const BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const getAuthHeaders = () => {
    const token = sessionStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

//Function for Call Get User Profile Detail Api 
export const getUserProfileDetail = async () => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/admin/user-profile-detail`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

// Function for Calling Submit Update User Profile API
export const updateUserProfile = async (formData) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/admin/update-user-profile`, {
            method: 'POST',
            headers: {
                ...headers,
            },
            body: formData,
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

// Function for Calling Submit Update User Email API
export const updateUserEmail = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/admin/update-profile-email`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

// Function for Calling Submit Update User Password API
export const updateUserPassword = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/admin/update-profile-password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Call Get All Customer List Api 
export const getCustomerList = async (currentPage,limit) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/admin/all-customer-list?page=${currentPage}&limit=${limit}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

/** Admin: open customer session without password (impersonation). */
export const impersonateCustomer = async (customerId) => {
    const headers = getAuthHeaders();
    try {
        const response = await fetch(`${BASE_URL}/admin/impersonate-customer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify({ customer_id: customerId }),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Could not open customer view');
        }

        return data;
    } catch (error) {
        throw error;
    }
};

/** Admin: real widget counts per app_type (all_app_templates) for one customer. */
export const getCustomerWidgetUsage = async (userId) => {
    const headers = getAuthHeaders();
    try {
        const q = new URLSearchParams({ user_id: String(userId) });
        const response = await fetch(`${BASE_URL}/admin/customer-widget-usage?${q.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Could not load widget usage');
        }

        return data;
    } catch (error) {
        throw error;
    }
};

/** Admin: customer plan / payment rows from plan_payment_history. */
export const getCustomerPlanHistory = async (userId, historyLimit = 100) => {
    const headers = getAuthHeaders();
    try {
        const q = new URLSearchParams({
            user_id: String(userId),
            limit: String(historyLimit),
        });
        const response = await fetch(`${BASE_URL}/admin/customer-plan-history?${q.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Could not load plan history');
        }

        return data;
    } catch (error) {
        throw error;
    }
};

/** Super-admin dashboard: user totals + monthly join trend (new API). */
export const getDashboardUserStats = async () => {
    const headers = getAuthHeaders();
    try {
        const response = await fetch(`${BASE_URL}/admin/dashboard-user-stats`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Could not load dashboard stats');
        }

        return data;
    } catch (error) {
        throw error;
    }
};

/** DB column `plans.limit` is enum('Unlimited') — every admin save sends this (do not send numbers). */
export const ADMIN_PLAN_LIMIT_VALUE = 'Unlimited';

/** Admin: list all plans */
export const getAdminPlans = async () => {
    const headers = getAuthHeaders();
    const response = await fetch(`${BASE_URL}/admin/plans`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', ...headers },
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Could not load plans');
    return data;
};

export const createAdminPlan = async (payload) => {
    const headers = getAuthHeaders();
    const body = { ...(payload || {}), limit: ADMIN_PLAN_LIMIT_VALUE };
    const response = await fetch(`${BASE_URL}/admin/plans`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...headers },
        body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Could not create plan');
    return data;
};

export const updateAdminPlan = async (planId, payload) => {
    const headers = getAuthHeaders();
    const body = { ...(payload || {}), limit: ADMIN_PLAN_LIMIT_VALUE };
    const response = await fetch(`${BASE_URL}/admin/plans/${planId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...headers },
        body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Could not update plan');
    return data;
};

export const deleteAdminPlan = async (planId) => {
    const headers = getAuthHeaders();
    const response = await fetch(`${BASE_URL}/admin/plans/${planId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', ...headers },
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Could not delete plan');
    return data;
};